// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  reportTemplatesDetails: Object,
};

const DeleteTemplate = (props: Props) => {
  const {
    visible,
    close,
    submit,
    reportTemplatesDetails,
  } = props;

  const deleteTemplate = () => {
    submit(reportTemplatesDetails.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteTemplate} type="danger">Delete</SpButton>,
      ]}
      title="Delete Report Template"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this template?</div>
        <SpH5 className="pb-3">
          <div>
            {(reportTemplatesDetails && reportTemplatesDetails.templateName)
              || <>&#8211;</>}
          </div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteTemplate;
